module.exports = __webpack_public_path__ + "static/media/Mobile-background.be284cc8.jpg";